export const QA_NAME_SEARCH_RESULTS_INHABITANTS_TABLE =
  'searchResultsInhabitantsTable'

export const SEARCH_RESULTS_INHABITANTS_CONFIG_API =
  'idwell-api/api/v3/table/tables/inhabitants-search/'

export const SEARCH_RESULTS_INHABITANTS_LIST_API =
  'idwell-api/api/v3/inhabitancy/inhabitants/search/'
